import React, { useMemo } from 'react'
import { useDataSource } from '../../../lib/dataSource'
import { ProjectIcon } from './ProjectIcon'
import { titleColorOf } from '../../../lib/projectIcon/projectTitle'

const PROJECT_PATH = /^\/home\/[^/]+\/project\/([^/?#]+)/

/** Die Projekt-ID eines Tab-Pfads (`/home/<bereich>/project/<id>`), sonst `null`. */
export function projectIdFromPath(path: string | undefined): string | null {
  return path?.match(PROJECT_PATH)?.[1] ?? null
}

/**
 * Das Icon eines Projekt-Tabs — **live aus dem Projekt gelesen**, nicht aus
 * dem Tab: Tabs werden gespeichert und in andere Fenster gereicht, ihr
 * `icon` ist dort nur ein Name. Ohne Projekt-Icon steht, was der Tab trägt.
 */
export const ProjectTabIcon: React.FC<{ projectId: string; size: number; fallback: React.ReactNode }> = ({
  projectId,
  size,
  fallback,
}) => {
  const project = useDataSource().useProject(projectId)
  if (!project?.icon) return <>{fallback}</>
  return <ProjectIcon icon={project.icon} iconColor={project.iconColor} size={size} fallback={fallback} />
}

/**
 * Die Farbe des Projekttitels für einen Tab — live aus dem Projekt, wie das
 * Icon (gewünscht 2026-09-26). `null` ohne Projekt oder ohne Farbe.
 */
export function useProjectTitleColor(projectId: string | null): string | null {
  const project = useDataSource().useProject(projectId ?? undefined)
  return useMemo(() => (projectId ? titleColorOf(project?.nameHtml) : null), [projectId, project?.nameHtml])
}
